import { createApi } from "@reduxjs/toolkit/query/react";

import apiBaseQuery from "./axiosBaseQuery";

export const TARGET_API_REDUCER_KEY = "targetApi";

export const targetApi = createApi({
  reducerPath: TARGET_API_REDUCER_KEY,
  baseQuery: apiBaseQuery,
  tagTypes: ["target"],
  endpoints: (builder) => ({
    getTargetList: builder.query({
      query: ({ page, limit, year }) => {
        return {
          url: `emissions/emission-target/?page=${page}&year=${
            year || ""
          }&limit=${limit}`,
        };
      },
      providesTags: ["target"],
    }),

    getTarget: builder.query({
      query: (id) => {
        if (!id) {
          return;
        }
        return {
          url: `emissions/emission-target/${id}/`,
        };
      },
      providesTags: ["target"],
    }),

    createTarget: builder.mutation({
      query: (body) => ({
        url: `emissions/emission-target/`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["target"],
    }),

    updateTarget: builder.mutation({
      query: ({ id, ...rest }) => ({
        url: `emissions/emission-target/${id}/`,
        method: "PUT",
        body: rest,
      }),
      invalidatesTags: ["target"],
    }),

    deleteTarget: builder.mutation({
      query: (id) => ({
        url: `emissions/emission-target/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["target"],
    }),
  }),
});

export const {
  useCreateTargetMutation,
  useDeleteTargetMutation,
  useGetTargetListQuery,
  useGetTargetQuery,
  useUpdateTargetMutation,
} = targetApi;
